module.exports = __webpack_public_path__ + "img/liveroomShareBg.41ad10d7.png";